module.exports = __webpack_public_path__ + "img/gastos.9cbd4ef4.png";